<script>
	import { Card, CardBody, CardSubtitle, Col, Row } from "sveltestrap";
	import { DynamicComponent } from "../../../../../store/store";

	import { navigate } from "svelte-routing";
	import { FontAwesomeIcon } from "fontawesome-svelte";
	import { faPenToSquare as fasPenToSquare } from "@fortawesome/free-solid-svg-icons";

	import "@splidejs/svelte-splide/css";
	import Exterior from "./PendingIssueTabs/Exterior.svelte";
	import Drive from "./PendingIssueTabs/Drive.svelte";
	import Tabs from "../../../../../components/Tabs/Tabs.svelte";

	import NoData from "../../../../../../src/components/NoDataPage/NoData.svelte";
	import Swal from "sweetalert2";

	export let issues;
	export let img_url = [];
	export let fetchIssue;

	let items = [
		{
			label: "Drive",
			value: 1,
			component: Drive,
		},
		{
			label: "Exterior",
			value: 2,
			component: Exterior,
		},
	];

	const options = {
		rewind: true,
		perPage: 2,
		gap: "1px",
		autoWidth: true,
		height: "15rem",
		arrows: img_url.length <= 2 ? false : true,
	};

	const handleClick = () => {
		DynamicComponent.set(2);
	};

	if (issues.pendingIssues == 0) {
		Swal.fire({
			title: "Warning",
			text: `No reported issue from FMS or CMS to review for ${issues.vehicleNumber}`,
			showCancelButton: false,
			confirmButtonColor: "#006DE1",
			timer: 8000,
			confirmButtonText: "Okay",
		});
		navigate("/issue-management/vehicle-issues");
	}
</script>

{#if !issues}
	<NoData />
{:else}
	<Col xs={12} class="d-flex justify-content-center px-2">
		<div class="me-2 justify-content-around mb-2">
			<b>Pending Issues Left for Vehicle {issues.vehicleNumber}:</b>
			<span class="status-bar-3 status-bar-info-issue"
				>{issues.pendingIssues}</span
			>
		</div>
	</Col>
	<Card class="mb-3">
		<CardBody>
			<Col xs={12} class="mt-4 px-2">
				<Col xs={12} class="d-flex justify-content-between px-2 ">
					<CardSubtitle
						><b>Issue ID: {issues.issueId}</b></CardSubtitle
					>
					<div>
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<p on:click={() => handleClick()}>
							<i><FontAwesomeIcon icon={fasPenToSquare} /></i>Edit
						</p>
					</div>
				</Col>
				<Col xs={12} class="d-flex justify-content-start px-2">
					<div class="mx-0">
						<h5 class="link-hover">
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<b
								class="link-text-hover"
								on:click={() =>
									navigate(
										`/car-management/details/${issues.vehicleId}`
									)}
							>
								{issues.vehicleMake +
									" " +
									issues.vehicleModel +
									" " +
									issues.vehicleNumber}
							</b>
						</h5>
					</div>
				</Col>
				<Col xs={6} class="d-flex justify-content-start px-2" />
			</Col>
			<Tabs
				{items}
				{options}
				{img_url}
				{issues}
				{fetchIssue}
				activeTab={issues.reportSection == "Exterior" ? 2 : 1}
				compareMode={true}
			/>
		</CardBody>
	</Card>
{/if}
